module.exports = __webpack_public_path__ + "img/65.51294785.png";